import { useState } from 'react'

import { getFormData } from '@components/DisplayForm/helpers'

import { useExecuteCommandMutation } from '@redux/api'

import { getCommandRequestData, normalizeExecuteCommandBody } from '@helpers'
import { GETCommand } from '@types'

export const useExecuteCommands = () => {
  const [executeCommand, { isLoading: loadingCommand, isError: isErrorCommand }] =
    useExecuteCommandMutation()

  const [data, setData] = useState<Record<string | number, unknown>[]>([])

  const executeAllCommands = async (
    commands: GETCommand[] = [],
    srcObj: Record<string, string | number> = {},
    formBody: Record<string, unknown> | undefined = {}
  ) => {
    const hasFile = formBody && Object.values(formBody).some(value => value instanceof File)

    try {
      const results = await Promise.all(
        commands.map(async cmd => {
          const outerBody = getCommandRequestData(cmd.body ?? [], srcObj)
          const hasOuterBody = Object.keys(outerBody).length > 0

          try {
            let data = null

            if (hasFile) {
              await executeCommand({
                method: cmd.httpMethod,
                objectCode: cmd.objectCode,
                commandCode: cmd.name,
                params: getCommandRequestData(cmd.parameters ?? [], srcObj),
                body: getFormData(formBody),
              })
            } else {
              const rawBody = hasOuterBody ? { ...outerBody, ...formBody } : formBody
              const normalizedBody = normalizeExecuteCommandBody(rawBody ?? {})

              data = await executeCommand({
                method: cmd.httpMethod,
                objectCode: cmd.objectCode,
                commandCode: cmd.name,
                body: normalizedBody,
                params: getCommandRequestData(cmd.parameters ?? [], srcObj),
              }).unwrap()
            }

            return { commandId: cmd.internalId, data, isError: false, error: null }
          } catch (err) {
            console.error(`Error executing command ${cmd.internalId}:`, err)

            return { commandId: cmd.internalId, data: null, isError: true, error: err }
          }
        })
      )

      setData(results)

      return results
    } catch (err) {
      console.error('Error executing commands:', err)
    }
  }

  return {
    executeAllCommands,
    isLoading: loadingCommand,
    isError: isErrorCommand,
    data,
  }
}
